import { Component, HostListener, OnInit, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { Router } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { InvoiceService } from '../../features/invoice/services/invoice.service';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';
// import { Store } from '@ngrx/store';
// import * as selectPermissions from '../../core/permissions/permission.selector';
import { AppComponent } from '../../app.component';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { PartnerTypesEnum } from '../../helpers/helper-file';
import { CreditDebitNoteService } from '../../features/credit-debit-note/services/credit-debit-note.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PaginationHelper } from '../../shared/services/pagination.service';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';

@Component({
  selector: 'app-invoice',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    AgGridAngular,
    // PermissionDirective,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
  ],
  templateUrl: './invoice.component.html',
  styleUrl: './invoice.component.scss',
})
export class InvoiceComponent implements OnInit {
  public viewPortSize: boolean = false;
  public rowData: any[] | null = null;
  private partnerTypes = PartnerTypesEnum;
  public loading: boolean = true;
  public error: any = null;
  private searchSubject = new Subject<string>();
  readonly dialog = inject(MatDialog);
  invoiceDashboardData: any;
  projectId: number;
  startDate: any;
  endDate: any;
  dateRangeForm: FormGroup;
  selectedCustomerId: any;
  customerSearchControl = new FormControl();

  dateFilter = (date: Date | null): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Remove time component
    return date ? date <= today : false;
  };

  columnDefs: (
    | {
        headerName: string;
        field: string;
        flex: number;
        valueFormatter?: undefined;
        cellRenderer?: undefined;
        floatingFilter?: undefined;
        filter?: undefined;
      }
    | {
        headerName: string;
        field: string;
        flex: number;
        valueFormatter: (params: any) => string;
        cellRenderer?: undefined;
        floatingFilter?: undefined;
        filter?: undefined;
      }
    | {
        field: string;
        headerName: string;
        flex: number;
        cellRenderer: (params: any) => HTMLDivElement;
        floatingFilter: boolean;
        filter: boolean;
        valueFormatter?: undefined;
      }
  )[];
  page = 0;
  pageSize = 10;
  totalPages = 1;
  pageSizeOptions = [5, 10, 20, 50, 100];
  public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];
  partnersList: any;
   canCreateInvoice$ = this.permissionService.hasPermission(
      ModuleIds.Invoice,
      'Create'
    );
    canEditInvoice$ = this.permissionService.hasPermission(
      ModuleIds.Invoice,
      'Edit'
    );
    canCancelInvoice$ = this.permissionService.hasPermission(
      ModuleIds.Invoice,
      'Cancel'
    );
    canEditInvoice:boolean = false;
    canCancelInvoice:boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {
    this.columnDefs = [
      {
        headerName: 'Invoice No',
        field: 'invoiceNo',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Order Code',
        field: 'orderCode',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Invoice Date',
        field: 'invoiceDate',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Customer Name',
        field: 'customerName',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Due Date',
        field: 'dueDate',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Total Amount',
        field: 'totalAmount',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Balance Amount',
        field: 'balance',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Payment Status',
        field: 'paymentStatus',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Invoice Status',
        field: 'invoiceStatus',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        field: 'action',
        headerName: 'Actions',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any) => {
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.style.gap = '20px';
          console.log(params);

          const status = params.data?.invoiceStatus;

          const isEditable = status !== 'Approved' && status !== 'Rejected' && status !== 'Sent';

          if (isEditable) {
            const editIcon = document.createElement('img');
            editIcon.src = 'assets/images/icons/icon-edit.svg';
            editIcon.style.cursor = 'pointer';
            editIcon.setAttribute('data-action', 'edit');
            if(this.canEditInvoice){
            container.appendChild(editIcon);
            }
            const deleteIcon = document.createElement('img');
            deleteIcon.src = 'assets/images/icons/icon-delete.svg';
            deleteIcon.style.cursor = 'pointer';
            deleteIcon.setAttribute('data-action', 'delete');
            if(this.canCancelInvoice){
            container.appendChild(deleteIcon);
            }
          }

          // this.store
          //   .select(selectPermissions.hasPermission('8', Permission.Delete))
          //   .subscribe((canDelete) => {
          //     if (canDelete) {
          //       container.appendChild(deleteIcon);
          //     }
          //   });
          return container;
        },
        floatingFilter: false,
        filter: false,
      },
    ];
  }
  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public themeClass: string = 'ag-theme-quartz';

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private invoiceService: InvoiceService,
    private datePipe: DatePipe,
    // private store: Store,
    private appComponent: AppComponent,
    private fb: FormBuilder,
    private itemService: CreditDebitNoteService,
    private permissionService: PermissionService
  ) {
    // const loggedInUser: any = localStorage.getItem('loggedInUser');
    // const userData = JSON.parse(loggedInUser);
    // this.profileName = userData?.profileData?.profileName;
  }

  ngOnInit(): void {
    this.getAllInvoices();
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.getAllInvoices(searchTerm);
      });

    this.checkViewportSize();

    this.dateRangeForm = this.fb.group({
      startDate: [''],
      endDate: [''],
      customerName: [''],
    });

    this.appComponent.toggleSidebar();
    this.canCancelInvoice$.subscribe((val) => {
      this.canCancelInvoice = val;
    });
    this.canEditInvoice$.subscribe((val) => {
      this.canEditInvoice = val;
    });
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.pageSize = 10;
    this.page = 0;
    this.searchSubject.next(searchTerm);
  }

  nextPage() {
    if (this.page + 1 < this.totalPages) {
      this.page++;
      this.getAllInvoices('', this.pageSize);
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.getAllInvoices('', this.pageSize);
    }
  }

  onPageSizeChange(event: Event): void {
    const newSize = Number((event.target as HTMLSelectElement).value);
    console.log('New Page Size:', newSize);
    this.pageSize = newSize;
    this.page = 0;
    this.getAllInvoices('', this.pageSize);
  }

  onDateChange(event: any, type: string) {
    const formattedDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
    if (type === 'start') {
      this.startDate = formattedDate;
    } else if (type === 'end') {
      this.endDate = formattedDate;
    }
    if (this.startDate != null && this.endDate != null) {
      this.getAllInvoices();
    }
  }

  getAllInvoices(search: string = '', pageSize: number = 10) {
    this.loading = true;
    if (pageSize) {
      this.pageSize = pageSize;
    }
    const skip = this.page * this.pageSize;

    const input = {
      limit: this.pageSize,
      skip: skip,
      search: search,
      startDate: this.startDate,
      endDate: this.endDate,
    };

    this.invoiceService
      .getAllInvoicesWithPagination(input)
      .subscribe({
        next: (data) => {
          this.totalPages = Math.ceil(
            (data?.total || data.invoices?.length) / this.pageSize
          );

          this.rowData = data?.invoices.map((invoice: any) => {
            return {
              id: invoice?.id,
              invoiceNo: invoice?.invoiceNo || '--',
              balance:
                invoice?.balance != null
                  ? `AED ${Number(invoice.balance).toFixed(2)}`
                  : '--',
              totalAmount:
                invoice?.totalAmount != null
                  ? `AED ${Number(invoice.totalAmount).toFixed(2)}`
                  : '--',
              orderCode: invoice?.orderData?.orderCode || '--',
              customerName:
                `${invoice?.customerData?.firstName ?? ''} ${
                  invoice?.customerData?.lastName ?? ''
                }`.trim() || '--',
              invoiceDate: invoice?.invoiceDate
                ? new Date(invoice.invoiceDate).toLocaleDateString('en-GB') // dd/mm/yyyy
                : '--',

              dueDate: invoice?.dueDate
                ? new Date(invoice.dueDate).toLocaleDateString('en-GB') // dd/mm/yyyy
                : '--',

              invoiceStatus: invoice?.invoiceStatus || '--',
              paymentStatus: invoice?.paymentStatus || '--',
            };
          });
          if (this.rowData) {
            this.paginationPageSizeSelector =
              PaginationHelper.getPaginationPageSizeOptions(this.rowData);
          } else {
            this.paginationPageSizeSelector = [];
          }
          this.loading = false;
        },
      });
  }

  openEdit(invoiceData: any) {
    const invoiceId = invoiceData?.id;
    if (invoiceId) {
      this.router.navigate([`/invoice/invoice-edit/${invoiceId}`]);
    }
  }

  onDeleteInvoice(invoiceData: any): void {

    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        title: 'Confirm Cancel',
        message: 'Are you sure you want to cancel this invoice?' , 
        confirmText: 'Confirm',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.removeInvoice(invoiceData?.id);
      }
    });
  }

  private removeInvoice(invoiceId: number): void {
    this.invoiceService.removeInvoiceById(invoiceId).subscribe({
      next: () => {
        this.toastr.success('Invoice removed successfully.');
        this.getAllInvoices();
      },
      error: (error) => {
        this.toastr.error(
          error.message || 'Failed to remove invoice. Please try again.'
        );
      },
    });
  }

  onCellClicked(params: any) {
    const invoiceId = params.data?.id;
    if (
      params.column.colId === 'action' &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;

      if (action === 'edit') {
        this.openEdit(params?.data);
      } else if (action === 'delete') {
        this.onDeleteInvoice(params?.data);
      }
    } else {
      const id = params.data?.id;
      // this.router.navigate([`invoice/invoice-details/${invoiceId}`]);
      this.router.navigate([`invoice/invoice-details`], {
        queryParams: { invoiceId: id },
      });
    }
  }

  onClear() {
    this.startDate = null;
    this.endDate = null;
    this.selectedCustomerId = null;
    this.dateRangeForm.reset();
    this.getAllInvoices();
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  isDropdownOpen = false;

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }
}
